// =============================================================
//  API URL Configuration — NCW Complaint Redressal System
//
//  Uses CRA dev-server proxy (src/setupProxy.js) so that:
//    • Local dev  (localhost:3010) works as-is
//    • Production (ncw.aibott.org:3010) works without CORS issues
//
//  The proxy routes:
//    /proxy-api/*  → Flask backend-api  (127.0.0.1:7001)
//    /proxy-llm/*  → LLM/FastAPI service (127.0.0.1:8085)
// =============================================================

// ---- ACTIVE: Proxy-relative URLs (work on any domain) ----
export const API_URL  = "/proxy-api/";   // Flask backend-api  (:7001)
export const CHAT_URL = "/proxy-llm/";   // LLM service (FastAPI, :8085)
export const AUTH_URL = "/proxy-api/";   // same Flask backend handles auth

// ---- Previous localhost URLs (for reference / quick rollback) ----
// export const API_URL  = "http://localhost:7001/";
// export const CHAT_URL = "http://localhost:8085/";
// export const AUTH_URL = "http://localhost:7001/";

// ---- External cloud URLs (old production) ----
// export const API_URL  = "https://cagapi.aibott.org/";
// export const CHAT_URL = "https://bashini.aibott.org/";
// export const AUTH_URL = "https://cagapi.aibott.org/";

// external — no local equivalent
export const OCR_URL = "https://ocr-tech.aibott.org/";

